import styled from 'styled-components';
import { SimpleButton } from 'edenred-ui';

export const StyledButton = styled(SimpleButton)`
  flex: 1;
  display: flex;
  font-size: ${({ theme }) => theme.sizeMedium};
  width: 100%;
`;
